import { ExtensionInterface } from 'probonio-shared-ui/registry/extension-definition';
import { ReactNode } from 'react';

export abstract class RoutesExtensionInterface extends ExtensionInterface {
  /**
   * @description Should return one or more <Route /> Components
   * @example
   * ```tsx
   * <>
   *     <Route path="/myPath" component={<MyComponent />} />
   * </>
   * ``` */
  get publicRoutes(): ReactNode | undefined {
    return undefined;
  }
  /**
   * @description Should return one or more <Route /> Components
   * @example
   * ```tsx
   * <>
   *     <Route path="/myPath" component={<MyComponent />} />
   * </>
   * ``` */
  get privateRoutes(): ReactNode | undefined {
    return undefined;
  }
}
